<template>
    <div class="movie-box">
        <div class="wrap-list">
            <div class="page-background-color-white item-wrap" v-for="(item, ind) in list" :key="ind">
                <div class="acea-row page-relative item-top">
                    <img class="border-radius06 mr2 item-top-img" :src="item.imgUrl || require('@/assets/images/defaultbgd.png')" />
                    <div class="acea-row row-column-around item-top-right-content">
                        <!-- 点券专区展示 -->
                        <div class="font-size24 color2B2B2B line-height5" v-if="item.coupon_type == '1'">
                            <span class="colorF6433D font-size36">{{item.total_coupon_price || '0'}}</span>点余额
                        </div>
                        <!-- 次券专区展示 -->
                        <div class="font-size24 color2B2B2B line-height5" v-if="item.coupon_type == '2'">
                            <span class="colorF6433D font-size36">{{item.total_coupon_price || '0'}}</span>次可兑换
                        </div>
                        <p class="font-size24 color2B2B2B">可用卡券{{item.total_coupon_num || '0'}}张</p>
                        <div class="font-size24 colorBEBEBE" @click="changeShow(ind)">
                            查看详情 <img class="page-inline-block icon-open xiala" v-if="item.isOpen" src="@/assets/images/icon_shouqi.png" />
                            <img class="page-inline-block icon-open xiala" v-else src="@/assets/images/icon_xiala.png" />
                        </div>
                    </div>

                    <div class="page-absolute bgdE2E2E2 colorWhite font-size28 page-text-center checkThisArea" v-if="item.isCurrent">
                        当前专区
                    </div>
                    <div class="page-absolute bgdF6433D colorWhite font-size28 page-text-center checkThisArea" @click="selectPart(item)" v-else>
                        选择专区
                    </div>
                </div>
                <div class="item-content-wrap" v-show="item.isOpen">
                    <p class="font-size28 cup-num">共计{{item.child.length || 0}}张卡券</p>
                    <div class="movie-box page-background-color-white item-content" v-for="(chil, index) in item.child" :key="index">
                    
                        <!-- 点券 -->
                        <div class="movie-box page-relative one-card" :class="{'disabled': chil._msg == '已过期' || chil.coupon_price == '0' }" v-if="item.coupon_type == '1'">
                            <div class="acea-row row-between row-middle one-card-top">
                                <span class="font-size24 color2B2B2B">{{chil.coupon_title || ''}}</span>
                                <span class="font-size24 color6D6D6D" v-if="chil._msg == '可使用'">有效期至：{{chil._end_time}}</span>
                                <span class="font-size24 color6D6D6D" v-if="chil._msg == '已过期'">已过期</span>
                                <span class="font-size24 color6D6D6D" v-if="chil.coupon_price == '0'">已用完</span>
                            </div>
                            <div class="acea-row row-between row-middle one-card-bottom">
                                <span class="color2B2B2B font-size24 font-weight650">
                                    <span class="font-size36">{{chil.coupon_price || '0'}}</span>点余额
                                </span>
                                <div class="">
                                    <!-- <router-link v-if="chil.coupon_price > 0 && chil._msg == '已过期' && !chil.isNotWechat" :to="{ path: '/user/account', query: { id: chil.coupon_title} }">
                                        <span class="page-inline-block colorWhite font-size24 bgdF6433D mr1 jiebang">充值延期</span>
                                    </router-link> -->
                                    <span v-if="item.isone"></span>
                                    <div v-else>
                                        <div v-if="item.isCurrent">
                                            <span v-if="index == 0"></span>
                                            <span class="page-inline-block colorWhite font-size24 bgdF6433D jiebang" @click="removeCou(chil.cid)" v-else>解绑</span>
                                        </div>
                                        <div v-else>
                                            <span class="page-inline-block colorWhite font-size24 bgdF6433D jiebang" @click="removeCou(chil.cid)">解绑</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <span class="page-absolute page-background-color-white circular cir-left"></span>
                            <span class="page-absolute page-background-color-white circular cir-right"></span>
                        </div>
                        <!-- 次券 -->
                        <div class="movie-box page-relative one-card" :class="{'disabled': chil._msg == '已过期' || chil.coupon_price == '0' }" v-if="item.coupon_type == '2'">
                            <div class="acea-row row-between row-middle one-card-top">
                                <span class="font-size24 color2B2B2B">{{chil.coupon_title || ''}}</span>
                                <span class="font-size24 color6D6D6D" v-if="chil._msg == '可使用'">有效期至：{{chil._end_time}}</span>
                                <span class="font-size24 color6D6D6D" v-if="chil._msg == '已过期'">已过期</span>
                                <span class="font-size24 color6D6D6D" v-if="chil.coupon_price == '0'">已用完</span>
                            </div>
                            <div class="acea-row row-between row-middle one-card-bottom">
                                <span class="color2B2B2B font-size24 font-weight650">
                                    <span class="font-size36">{{chil.coupon_price || '0'}}</span>次可兑换
                                </span>
                                <div class="">
                                    <span v-if="item.isone"></span>
                                    <div v-else>
                                        <div v-if="item.isCurrent">
                                            <span v-if="index == 0"></span>
                                            <span class="page-inline-block colorWhite font-size24 bgdF6433D jiebang" @click="removeCou(chil.cid)" v-else>解绑</span>
                                        </div>
                                        <div v-else>
                                            <span class="page-inline-block colorWhite font-size24 bgdF6433D jiebang" @click="removeCou(chil.cid)">解绑</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <span class="page-absolute page-background-color-white circular cir-left"></span>
                            <span class="page-absolute page-background-color-white circular cir-right"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "SelectZone",
    data: function () {
        return {
            isOpenList: false,
            list: []
        }
    },
    props: {
        data: {
            type: Array,
            default: ()=>[]
        }
    },
    watch: {
        data: {
            deep: true,
            handler(val) {
                // console.log("接收", val);
                this.list = val;
            }
        }
    },
    methods: {
        changeShow(ind) {
            let _open = this.list[ind].isOpen;
            this.list[ind].isOpen = !_open;
        },
        removeCou(id) {
            // this.$dialog.confirm({
            //     mes: '确定解绑此卡券吗？',
            //     opts: ()=>{
                    this.$emit('removeCou', id);
            //     }
            // });
        },
        // 选择专区
        selectPart(item) {
            let id = item.child[0].id || '';
            let data = {
                id,
                kahao: item.child[0].coupon_title || '',
                cid: item.child[0].cid || ''
            }
            this.$emit('selectPart', data);
        }
    }
}
</script>

<style scoped lang="scss">
.item-wrap {
    margin-bottom: 0.16rem;
    .cup-num {
        padding-left: 0.16rem;
        margin: 0.32rem 0 0 0;
    }
}
.item-top {
    padding: .16rem 1.72rem .16rem .16rem;
    height: 1.74rem;
    border-radius: 0.08rem;
    box-shadow: 0 0.06rem 0.16rem 0.02rem rgba(0,0,0,0.1);
    .checkThisArea {
        width: 1.52rem;
        height: 0.48rem;
        line-height: 0.48rem;
        border-radius: 0.24rem;
        top: 0.62rem;
        right: 0.16rem;
    }
}
.item-top-img {
    width: auto;
    height: 1.4rem;
}
.item-top-right-content {
    flex:1;
    .xiala {
        vertical-align: middle;
    }
}
.icon-open {
    width: .24rem;
}
.item-content-wrap {
    padding-bottom: 0.08rem;
    background: #fff;
}
.item-content {
    padding: 0.08rem 0.16rem 0.08rem;
    border-radius: 0 0 0.08rem 0.08rem;
    .one-card {
        background: #FFECEC;
        border-radius: 0.08rem;
        padding: 0 0.16rem;
        // margin-top: 0.08rem;
        .one-card-top {
            height: 0.7rem;
            border-bottom: 0.02rem dashed #fff;
        }
        .one-card-bottom {
            height: 0.8rem;
        }
        .circular {
            width: 0.26rem;
            height: 0.26rem;
            border-radius: 50%;
            top: 0.56rem;
        }
        .cir-left {
            left: -0.16rem;
        }
        .cir-right {
            right: -0.16rem;
        }
        .jiebang {
            padding: 0.08rem 0.22rem;
            border-radius: 0.24rem;
        }
    }
    .disabled {
        background: #EAEAEA !important;
    }
}
</style>